<template>
  <app-base-main
      no-padding
      parentTable
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          @query="$gjNoticeQuery"
          @reset="$gjReset"
          :reset="false">
        <gj-select
            v-if="false"
            v-model="filter.state"
            placeholder="状态"
            :options="AdKeywordEnum.SP.statusOption"
        ></gj-select>
        <gj-select
            v-model="filter.matchType"
            placeholder="匹配类型"
            :options="AdKeywordEnum.SP.matchTypeOption">
        </gj-select>
        <gj-search-input
            v-model="filter.keyword"
            width="180px"
            placeholder="关键词"
        ></gj-search-input>
        <gj-date-picker
            v-model="filter.date"
            type="daterange"
            tooltip="数据时间"
            :clearable="false"
            :max-day-length="180"
        ></gj-date-picker>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-checkbox
          v-model="filter.filterAdZero"
          @input="$gjNoticeQuery">
        <span style="color: #666">过滤广告业绩为0的数据</span>
      </gj-checkbox>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :index="false"
          name="asinKeywordAnalysis"
          :data="tableData"
          :columns="columns"
          show-summary
          :loading="loading"
          :pagination="pagination"
          :default-sort="defaultSort"
          :offsetHeight="6"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:keywordText="{row}">
          [ {{ row.matchType | optionText(AdKeywordEnum.SP.matchTypeOption) }} ]
          <gj-link :href="row.amazonUrl" target="_blank">{{row.keywordText}}</gj-link>
        </template>
        <template v-slot:campaignName="{row}">
          <div v-gutter="4">
            <app-ad-route-link
                :market-id="marketId"
                :type="AdTypeEnum.SP"
                :campaign="row">
              {{row.campaignName}}
            </app-ad-route-link>
            <span>&gt;</span>
            <app-ad-route-link
                :market-id="marketId"
                :type="AdTypeEnum.SP"
                :campaign="row"
                :group="row"
                :group-targeting-type="AdGroupEnum.SP.targetingType.KEYWORD">
              {{row.groupName}}
            </app-ad-route-link>
          </div>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../../common/fields";
  import {AdCampaignEnum, AdKeywordEnum, AdGroupEnum} from "../../../common/enum";
  import {defaultVal, isMeaningful} from "../../../../../../utils/common";
  import {convertToDate} from "../../../../../../utils/date.util";
  import {getAdsAsinPerformanceKeyword} from "../../../../../../api/ad";
  import {queryMixin} from "../../../../../../minxins";
  import {adDefaultSortMixin, adTypeRouteMixin, currencySymbolMixin} from "../../../common/mixin";
  import AppAdRouteLink from "../../../common/components/app-ad-route-link";

  export default {
    name: "app-asin-keyword-analysis",
    components: {AppAdRouteLink},
    mixins: [queryMixin, adTypeRouteMixin, currencySymbolMixin, adDefaultSortMixin],
    props: {
      marketId: {
        required: true,
      },
      currencySymbol: {
        required: true,
      },
      item: {
        required: true
      },
      queryDate: {
        required: true
      }
    },
    created() {
      this.filter.date = this.queryDate;
      /*this.sort.prop = 'impressions';*/
    },
    data() {
      return {
        tableData: [],
        columns: [
          {...adFields.keywordName, fixed: null, minWidth: '200px'},
          {...adFields.orders, width: '130px'},
          {...adFields.cvr, width: '90px'},
          {...adFields.bid, field: 'bid', summary: true, width: '70px'},
          adFields.cost,
          adFields.cpc,
          // adFields.orderProductSales,
          adFields.acos,
          adFields.impressions,
          adFields.clicks,
          adFields.ctr,
          adFields.cpa,
          {...adFields.campaignName, fixed: null, minWidth: '250px'},
          {
            ...adFields.servingStatus,
            width: '100px',
            options: [...AdCampaignEnum.SP.servingStatusOption, ...AdCampaignEnum.SB.servingStatusOption],
            defaultShow: '广告活动已暂停'
          }
        ],
        filter: {
          state: null,
          matchType: null,
          filterAdZero: false,
          keyword: null,
          date: [],
        },
        AdKeywordEnum: AdKeywordEnum,
        AdGroupEnum: AdGroupEnum
      }
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            marketId: this.marketId,
            dataType: this.filter.filterAdZero ? 1 : 0,
            // status: this.filter.state,
            msku: this.item.msku,
            keywordTex: this.filter.keyword,
            matchType: defaultVal(this.filter.matchType, null),
            startDate: convertToDate(this.filter.date[0]),
            endDate: convertToDate(this.filter.date[1]),
          },
          ...this.queryPagination,
          ...this.querySortEx
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getAdsAsinPerformanceKeyword(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = this.currencySymbolMixin(data.records, this.currencySymbol);
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          })
      },
    }
  }
</script>

<style lang="scss" scoped>
/deep/ .gj-table .gj-help--icon .gj-icon{
  color: #999999;
}
</style>
